export const formatCurrency = (
  num: number,
  options: Intl.NumberFormatOptions = {},
) =>
  // TODO parameterize the the locale once go multi-language
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    ...options,
  }).format(num);
